import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

/** Small dialog asking for a single name (new folder, rename, new drive). */
const NameDialog = ({ open, onOpenChange, title, description, initial = '', confirmLabel = 'Save', onSubmit }) => {
  const [value, setValue] = useState(initial);
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setValue(initial);
    // Select the name without its extension, like Finder/Explorer do
    setTimeout(() => {
      const input = inputRef.current;
      if (!input) return;
      input.focus();
      const dot = initial.lastIndexOf('.');
      input.setSelectionRange(0, dot > 0 ? dot : initial.length);
    }, 30);
  }, [open, initial]);

  const submit = async (e) => {
    e.preventDefault();
    const name = value.trim();
    if (!name) return;
    setBusy(true);
    const ok = await onSubmit(name);
    setBusy(false);
    if (ok !== false) onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
          <label className="mt-5 block">
            <span className="sr-only">Name</span>
            <input
              ref={inputRef}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className="h-10 w-full rounded-lg border border-input bg-background px-3 text-[15px] outline-none focus:border-primary focus:ring-2 focus:ring-ring/30"
            />
          </label>
          <DialogFooter>
            <Button type="button" variant="outline" className="h-9 rounded-lg" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" className="h-9 rounded-lg font-semibold" disabled={busy || !value.trim()}>{confirmLabel}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default NameDialog;
